/* tslint:disable */
/* eslint-disable */
/**
 * Unified API STS Service Public
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface CommonErrorUnsupportedMediaTypeError {
    'code': CommonErrorUnsupportedMediaTypeErrorCodeEnum;
    'message': string;
}

export enum CommonErrorUnsupportedMediaTypeErrorCodeEnum {
    UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE'
}


